import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const NOTICE_KEY = 'authNotice';

/**
 * Picks up the `authNotice` sessionStorage marker left behind by a
 * failed role/partner lookup (see HeaderBanner.tsx), which ends the
 * Auth0 session via a full-page logout redirect back to the app origin.
 * That full reload loses React Router's in-memory `location.state`, so
 * this component re-issues the notice as a proper client-side navigation
 * to `/user-login` once the app remounts, instead of relying on an
 * arbitrary Auth0 `returnTo` path (which must be pre-registered in
 * Auth0's Allowed Logout URLs and would otherwise surface Auth0's own
 * error page).
 */
function AuthNoticeRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const notice = sessionStorage.getItem(NOTICE_KEY);
    if (notice && location.pathname !== '/user-login') {
      sessionStorage.removeItem(NOTICE_KEY);
      navigate('/user-login', { state: notice });
    }
    // Only ever needs to run once per app load / route change; the
    // marker is consumed on read.
  }, [location.pathname, navigate]);

  return null;
}

export default AuthNoticeRedirect;
